import OffersDialogueButton from './OffersDialogueButton';

export default OffersDialogueButton;
